import { render, staticRenderFns } from "./statistics_detail.vue?vue&type=template&id=2ac99864&scoped=true&"
import script from "./statistics_detail.vue?vue&type=script&lang=js&"
export * from "./statistics_detail.vue?vue&type=script&lang=js&"
import style0 from "./statistics_detail.vue?vue&type=style&index=0&id=2ac99864&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac99864",
  null
  
)

export default component.exports